<template>
    <div class="sr-table" :class="{ striped: striped }">
        <VDataTable v-bind="$attrs" :headers="headers" :items="items" :hide-default-footer="!showFooter" v-on="$listeners">
            <!-- table heading slot -->
            <template v-if="showTableHeader" #top>
                <SrTableHeading :image="image" :title="title" />
            </template>

            <!-- table header slots -->
            <template v-for="headerSlotKey in headerSlots" #[headerSlotKey]="{ header }">
                <slot :name="headerSlotKey" v-bind="header" />
            </template>

            <!-- table column slots -->
            <template v-for="headerConfig in headers" #[getSlotName(headerConfig)]="{ item, value }">
                <slot
                    v-if="changeableItemSlots.includes(getValueKey(headerConfig))"
                    :name="getValueKey(headerConfig)"
                    v-bind="item"
                    :item="item"
                />

                <SrTableColumn
                    v-else-if="value !== undefined"
                    :key="getValueKey(headerConfig)"
                    :value="value"
                    :config="headerConfig.valueConfig"
                />
            </template>
        </VDataTable>
    </div>
</template>

<script>
import SrTableHeading from './SrTableHeading';
import SrTableColumn from './SrTableColumn';

// for other props refer to https://vuetifyjs.com/en/components/data-tables
export default {
    name: 'SrTable',
    components: { SrTableHeading, SrTableColumn },
    props: {
        showFooter: Boolean,
        striped: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: '',
        },
        image: {
            type: String,
            default: '',
        },
        headers: {
            type: Array,
            default: () => [],
        },
        items: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        headerSlots() {
            const slotKeys = Object.keys(this.$scopedSlots);

            return slotKeys.filter((key) => key.includes('header.'));
        },
        changeableItemSlots() {
            const changeableScopes = Object.keys(this.$scopedSlots);
            const availableHeaders = this.headers.map((header) => header.value);

            return changeableScopes.filter((slot) => availableHeaders.includes(slot));
        },
        showTableHeader() {
            return Boolean(this.title || this.image);
        },
    },
    methods: {
        getValueKey(headerConfig) {
            return headerConfig.value;
        },
        getSlotName(headerConfig) {
            return `item.${this.getValueKey(headerConfig)}`;
        },
    },
};
</script>
